// extracted by mini-css-extract-plugin
export default {"root":"Page_root__BhI+u","header":"Page_header__BXrQv","root_telekom":"Page_root_telekom__Owe7k"};